import { IsOptional, IsNotEmpty, IsString, IsUUID, IsEmail, IsEnum, IsPhoneNumber, IsBoolean } from 'class-validator';
import { SortStrategy, SortString, Status } from '../project.entity';

export class ProjectFindDto {
	@IsOptional()
	@IsUUID('4')
	id?: string;

	@IsOptional()
	@IsString()
	@IsNotEmpty()
	name?: string;

	@IsOptional()
	@IsUUID('4')
	userId?: string;

	@IsOptional()
	@IsEmail()
	userEmail?: string;

	@IsOptional()
	@IsPhoneNumber()
	userPhone?: string;

	@IsOptional()
	@IsUUID('4')
	businessId?: string;

	@IsOptional()
	@IsString()
	@IsNotEmpty()
	businessName?: string;

	@IsOptional()
	@IsString()
	@IsNotEmpty()
	vehicle?: string;

	@IsOptional()
	@IsEnum(Status)
	status?: Status;

	@IsOptional()
	@IsEnum(SortStrategy)
	sort?: SortStrategy;

	@IsOptional()
	@IsEnum(SortString)
	sortBy?: SortString;

	/**
	 * Opt-in to load the `cartItems` relation (and richer user/business relations)
	 * so summaries can render thumbnails. Defaults to false to keep the existing
	 * table-data call path small. Used by the MCP `list_projects` tool.
	 */
	@IsOptional()
	@IsBoolean()
	includeCartItems?: boolean;
}
